module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/creditos/verde/detalles/verde-detalles.component.scss
// module id = ./src/app/creditos/verde/detalles/verde-detalles.component.scss
// module chunks = main